module.exports = __webpack_public_path__ + "static/media/CommentInput_TYPE.4a26557c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CommentInput_TYPE.png
// module id = 287
// module chunks = 0